import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Text, Spinner, Button, Image } from "@chakra-ui/react";
import { useAudioCall } from "../hooks/useAudioCall";

const OutgoingCallPage = () => {
  const { calleeId } = useParams();
  const [myId, setMyId] = useState(null);
  const [calleeInfo, setCalleeInfo] = useState(null);

  const { startCall } = useAudioCall(myId, calleeId);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setMyId(userInfo?._id);

    const fetchCallee = async () => {
      try {
        const res = await fetch(
          `https://connect.csaappstore.com/api/user/${calleeId}`
        );
        const contentType = res.headers.get("content-type");

        if (!res.ok) throw new Error("Failed to fetch user");

        if (!contentType || !contentType.includes("application/json")) {
          const text = await res.text();
          throw new Error(`Invalid JSON response: ${text.slice(0, 100)}`);
        }

        const data = await res.json();
        setCalleeInfo(data);
      } catch (err) {
        console.error("Error fetching callee info:", err);
      }
    };

    if (calleeId) fetchCallee();
  }, [calleeId]);

  useEffect(() => {
    if (myId && calleeInfo) {
      startCall();
    }
  }, [myId, calleeInfo, startCall]);

  if (!calleeInfo) {
    return (
      <Box textAlign="center" mt={10}>
        <Spinner size="xl" />
        <Text mt={2}>Fetching callee info...</Text>
      </Box>
    );
  }

  return (
    <Box textAlign="center" mt={10}>
      <Image
        src={calleeInfo.pic}
        borderRadius="full"
        boxSize="150px"
        mx="auto"
        alt={calleeInfo.name}
      />
      <Text fontSize="2xl" mt={4}>
        Calling {calleeInfo.name}...
      </Text>
      <Text>Email: {calleeInfo.email}</Text>
      <Text>User ID: {calleeInfo._id}</Text>
      <Text color="gray.500" mt={2}>
        Waiting for them to answer
      </Text>
    </Box>
  );
};

export default OutgoingCallPage;
